module.exports = __webpack_public_path__ + "static/media/pe.fda66729.svg";